import { Component, Inject, OnDestroy, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators, ReactiveFormsModule } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { CompanyManagementService } from 'src/app/services/dataLayer/CAM/company-management.service';
import { DataLayerService } from 'src/app/services/dataLayer/datalayer.service';
import { CommonService } from 'src/app/shared/common/common.service';
import { environment } from 'src/environments/environment';
import { MatIconButton, MatButton } from '@angular/material/button';
import { MatIcon } from '@angular/material/icon';
import { NgFor, NgClass, NgIf, NgStyle } from '@angular/common';
import { MatFormField } from '@angular/material/form-field';
import { MatInput } from '@angular/material/input';
import { MatProgressSpinner } from '@angular/material/progress-spinner';
import { TravelerManagement } from 'src/app/services/dataLayer/CAM/traveler-management.service';
import { SignUpContentServiceService } from 'src/app/modules/registration/services/sign-up-content-service.service';
import { Subject, takeUntil } from 'rxjs';

@Component({
    selector: 'app-otp-verification-dialog',
    templateUrl: './otp-verification-dialog.component.html',
    styleUrls: ['./otp-verification-dialog.component.scss'],
    imports: [ReactiveFormsModule, MatIconButton, MatIcon, NgFor, MatFormField, NgClass, MatInput, NgIf, NgStyle, MatButton, MatProgressSpinner]
})
export class OtpVerificationDialogComponent implements OnInit, OnDestroy {

method:string =''
enableCompanyType: string = '';
companyChangeDomainType: string = '';
authTypes:any;
travelerPersonalinfoType:any;
  constructor( public _MatDialogRef: MatDialogRef<OtpVerificationDialogComponent>, @Inject(MAT_DIALOG_DATA) public data: any, private _CommonService:CommonService, private _companyManagementService:CompanyManagementService,private _datalayer:DataLayerService,private readonly travelerManagement: TravelerManagement, private readonly signUpContentService: SignUpContentServiceService ) 
  {
    this.method = this.data?.method
    this.enableCompanyType = data?.EnableCompanyLogin;
    this.companyChangeDomainType = data?.companyChangeDomain;
    this.authTypes = data?.authType;
    this.travelerPersonalinfoType = this.data?.method;
    console.log('sdsad',data);
   }
  onCancel(): void {
    //call the event of 1. close Gtm
    const authType = this.verifyMode === 'mobile' ? 'mobile' : 'email';
     const closeType =
        this.verifyMode === 'mobile'
            ? 'Step2-Verify your phone'
            : 'Step1-Verify your email address';
    if (this.enableCompanyType == 'CompanyLogin') {
      this._companyManagementService.company_login_authentication(closeType,'Close');
    }else{
      if (this.companyChangeDomainType == 'isChangeDomain') {
        this._companyManagementService.email_domain_authentication('Close','Close');
      }else{
        if (this.authTypes == 'Onboard') {
          this._datalayer.onboarding_authentication_click(authType, 'Close', this.resendAttemptsLeft, this.data?.userType == '0' ? 'Admin' : 'Employee');
        }
      }
      
    }
 // GTM Verify Click
      if (this.travelerPersonalinfoType == 'personalInfoMobMatch') {
        this.travelerManagement.authentication_popupMatch('Close','Close', authType);
      }
    this._MatDialogRef.close()
  }

  digitControlNames = ['digit1', 'digit2', 'digit3', 'digit4', 'digit5', 'digit6'];
  otpForm = new FormGroup({
    digit1: new FormControl('', [Validators.required, Validators.pattern(/^\d$/)]),
    digit2: new FormControl('', [Validators.required, Validators.pattern(/^\d$/)]),
    digit3: new FormControl('', [Validators.required, Validators.pattern(/^\d$/)]),
    digit4: new FormControl('', [Validators.required, Validators.pattern(/^\d$/)]),
    digit5: new FormControl('', [Validators.required, Validators.pattern(/^\d$/)]),
    digit6: new FormControl('', [Validators.required, Validators.pattern(/^\d$/)]),
  });

  timer: number = environment.ResendTimer || 60;
  countdown: string = '01:00';
  private timerInterval: any;
  showTimer: boolean = true;
  resendAttemptsLeft: number = 3;
  invalidOtpAttemptsLeft: number = 5;

  isVerifying: boolean = false;
  isResending: boolean = false;
  showErrorMsg: string | null = null;

  email: string = '';
  maskedEmail: string = '';
  otpChecksum: string | null = null;
  verifyMode: 'email' | 'mobile' = 'email';
  step: number = 1;
  totalSteps: number = 2;
  headerMessage: string = '';
  infoMessage: string = '';
  content: any;
  private readonly destroy$ = new Subject<void>();

  get isOtpComplete(): boolean {
    return this.digitControlNames.every(name => {
      const ctrl = this.otpForm.get(name);
      return !!ctrl && !!ctrl.value && ctrl.valid;
    });
  }

  getRegisterWarning(messageId: string): any {
    return this.content?.warningList?.find((item: any) => item?.messageID === messageId);
  }

  allowNumbersOnly(event: KeyboardEvent) {
    const charCode = event.which ? event.which : event.keyCode;
    if (charCode < 48 || charCode > 57) {
      event.preventDefault();
    }
  }
  moveNext(event: any, index: number) {
    if (!event?.target?.value) return;
    if (index >= this.digitControlNames.length - 1) return;

    const nextId = this.digitControlNames[index + 1];
    const nextInput = document.getElementById(nextId) as HTMLInputElement | null;
    nextInput?.focus();
  }

  movePrev(event: any, index: number) {
    const target = event.target as HTMLInputElement;
    if (index <= 0) return;
    if (target?.value) return;

    const prevId = this.digitControlNames[index - 1];
    const prevInput = document.getElementById(prevId) as HTMLInputElement | null;
    prevInput?.focus();
  }

  get otpBoxes() {
    return new Array(6);
  }

  private startCountdown(): void {
    if (this.timerInterval) clearInterval(this.timerInterval);
    let time = this.timer;
    this.showTimer = true;
    this.countdown = `${this.formatTime(Math.floor(time / 60))}:${this.formatTime(time % 60)}`;

    this.timerInterval = setInterval(() => {
      time--;
      const minutes = Math.floor(time / 60);
      const seconds = time % 60;
      this.countdown = `${this.formatTime(minutes)}:${this.formatTime(seconds)}`;

      if (time <= 0) {
        clearInterval(this.timerInterval);
        this.showTimer = false;
      }
    }, 1000);
  }

  private formatTime(time: number): string {
    return time < 10 ? '0' + time : time.toString();
  }

  ngOnInit(): void {
    this.signUpContentService.content$.pipe(takeUntil(this.destroy$)).subscribe((res: any) => {
      this.content = res;
    });
    //call the event of 1. PopUp_pageview Gtm
    const authType = this.verifyMode === 'mobile' ? 'mobile' : 'email';
    // this._companyManagementService.company_login_authentication('PopUp_pageview','View popup');
    this.verifyMode = (this.data?.verifyMode || 'email') as 'email' | 'mobile';
    this.step = this.data?.step || 1;
    this.totalSteps = this.data?.totalSteps || 2;
    this.otpChecksum = (this.data?.otpChecksum || null) as string | null;
    if (this.enableCompanyType !== 'CompanyLogin') {
      if (this.companyChangeDomainType == 'isChangeDomain') {
        this._companyManagementService.email_domain_authentication('Popup','PopUp_pageview');
      }else{
        if (this.authTypes == 'Onboard') {
          this._datalayer.onboarding_authentication_click(authType, 'Popup_pageview', 0, this.data?.userType == '0' ? 'Admin' : 'Employee');
        }
      }
      
    }else{
      if(this.verifyMode === 'mobile'){
        this._companyManagementService.company_login_authentication('Step2-Verify your phone','PopUp_pageview');
      }
      
    }

    // GTM Verify Click
    const closeType =
        this.verifyMode === 'mobile'
            ? 'Step2-Verify your phone'
            : 'Step1-Verify your email address';
      if (this.travelerPersonalinfoType == 'personalInfoMobMatch') {
        this.travelerManagement.authentication_popupMatch(closeType,'PopUp_pageview', this.verifyMode === 'mobile' ? 'mobile' : 'email');
      }
    

    if (this.verifyMode === 'mobile') {
      const phone = (this.data?.PhoneNumber || '').toString();
      const isdCode = (this.data?.isdCode || '').toString();
      this.maskedEmail = this.maskMobileWithCountryCode(phone, isdCode);
      this.infoMessage = 'A verification code has been sent to your mobile number';
    } else {
      this.email = (this.data?.Email || '').toString();
      this.maskedEmail = this.maskEmail(this.email);
      this.infoMessage = 'A verification code has been sent to your email ID';
    }

    this.startCountdown();
    console.log(this.isVerifying)
    this._CommonService.loader$.subscribe(value =>{
      this.isVerifying = value;
    })

    console.log(this.isVerifying)
  }

  maskEmail(email: string): string {
    if (!email) return '';

    const [localPart, domain] = email.split('@');

    if (localPart.length <= 2) {
      return `**@${domain}`;
    }

    const visiblePart = localPart.slice(-5); // show last few chars
    const maskedPart = '*'.repeat(localPart.length - visiblePart.length);

    return `${maskedPart}${visiblePart}@${domain}`;
  }

  private maskMobileWithCountryCode(
    mobile: string,
    countryCode: string
  ): string {
    if (!mobile || mobile.length < 3) return `${countryCode ? countryCode + ' ' : ''}${mobile}`;
    const maskedMobile = `*********${mobile.slice(-3)}`;
    return `${countryCode ? countryCode + ' ' : ''}${maskedMobile}`;
  }

  async onResendCodeClick(): Promise<void> {
    //call the event of 1. resend Gtm
    const authType = this.verifyMode === 'mobile' ? 'mobile' : 'email';
    const closeType =
        this.verifyMode === 'mobile'
            ? 'Step2-Verify your phone'
            : 'Step1-Verify your email address';
    if (this.enableCompanyType == 'CompanyLogin') {
      this._companyManagementService.company_login_authentication(closeType,'Resend');
    }else{
      if (this.companyChangeDomainType == 'isChangeDomain') {
        this._companyManagementService.email_domain_authentication('Resend', 'Resend');
      } else {
        if (this.authTypes == 'Onboard') {
          this._datalayer.onboarding_authentication_click(authType, 'Resend', this.resendAttemptsLeft, this.data?.userType == '0' ? 'Admin' : 'Employee');
        }
      }
    }
    
    // GTM Verify Click
    if (this.travelerPersonalinfoType == 'personalInfoMobMatch') {
      this.travelerManagement.authentication_popupMatch(closeType, 'Resend', authType);
    }

    this.showErrorMsg = null;
    if (this.resendAttemptsLeft <= 0 || this.showTimer || this.isResending) return;
    if (!this.data?.onResend) return;

    try {
      this.isResending = true;
      this.otpForm.reset();
      const result = await this.data.onResend();
      if (result?.success) {
        this.otpChecksum = result.checksum || this.otpChecksum;
        this.resendAttemptsLeft--;
      } else if (result?.message) {
        this.showErrorMsg = result.message;
        if (this.enableCompanyType == 'CompanyLogin') {
          this._companyManagementService.authentication_error('Verify',result.message);
        }else{
          if (this.authTypes == 'Onboard') {
            this._datalayer.errors_occured(result.message, this.data?.userType == '0' ? 'Admin' : 'Employee');
          }
        }
        
      }
      this.isResending = false;
      this.startCountdown();
    } catch (err: any) {
      this.isResending = false;
      this.showErrorMsg = err?.message || err?.message || 'Failed to resend code. Please try again.';
      if (this.enableCompanyType == 'CompanyLogin') {
        this._companyManagementService.authentication_error('Verify',err?.message || err?.message || 'Failed to resend code. Please try again.');
      }else{
        if (this.authTypes == 'Onboard') {
          this._datalayer.errors_occured(err?.message, this.data?.userType == '0' ? 'Admin' : 'Employee');
        }
      }
      console.error(err);
    }
  }

  private markInvalidOtp(): void {
    this.invalidOtpAttemptsLeft--;
    Object.keys(this.otpForm.controls).forEach((key) => {
      const control = this.otpForm.get(key);
      control?.setErrors({ incorrect: true });
    });
    this.showErrorMsg =
      this.invalidOtpAttemptsLeft > 0
        ? `Invalid OTP! You have ${this.invalidOtpAttemptsLeft} attempts left.`
        : 'Verification attempts maxed out. Please try again later.';
  }

  async onVerify(): Promise<void> {
    this.showErrorMsg = null;
     
    if (this.otpForm.invalid || this.isVerifying) return;
    if (!this.data?.onVerify) return;

    const otp = Object.values(this.otpForm.value).join('');
    try {
      this.isVerifying = true;
      const result = await this.data.onVerify(otp, this.otpChecksum);
      // this.isVerifying = false;
      const authType = this.verifyMode === 'mobile' ? 'mobile' : 'email';
      const closeType =
        this.verifyMode === 'mobile'
            ? 'Step2-Verify your phone'
            : 'Step1-Verify your email address';
      if (this.enableCompanyType == 'CompanyLogin') {
        this._companyManagementService.company_login_authentication(closeType,'Verify');
      }else{
        if (this.companyChangeDomainType == 'isChangeDomain') {
          this._companyManagementService.email_domain_authentication('Verify', 'Verify');
        } else {
          if (this.authTypes == 'Onboard') {
            this._datalayer.onboarding_authentication_click(authType, 'Verify', this.invalidOtpAttemptsLeft, this.data?.userType == '0' ? 'Admin' : 'Employee');
          }
        }
      }
      // GTM Verify Click
      if (this.travelerPersonalinfoType == 'personalInfoMobMatch') {
        this.travelerManagement.authentication_popupMatch(closeType,'Verify', authType);
      }
      
      if (result?.success) {
          //call the event of 1. close gtm
          
        if (this.enableCompanyType == 'CompanyLogin') {
          const closeType =
              this.verifyMode === 'mobile'
                  ? 'Step2-Verify your phone'
                  : 'Step1-Verify your email address';
          this._companyManagementService.authentication_success(closeType, 'Success');
        } else {
          if (this.companyChangeDomainType == 'isChangeDomain') {
            this._companyManagementService.email_domain_authentication('Verify', 'Success');
          } else {
            if (this.authTypes == 'Onboard') {
              this._datalayer.onboarding_authentication_click(authType, 'Success', this.invalidOtpAttemptsLeft, this.data?.userType == '0' ? 'Admin' : 'Employee');
            }
          }
        }
        // GTM Verify Click
      if (this.travelerPersonalinfoType == 'personalInfoMobMatch') {
        this.travelerManagement.authentication_popupMatch(closeType,'Success', authType);
      }
        this._MatDialogRef.close({ verified: true });
      } else if (result?.message) {
        this.showErrorMsg = result.message;
        if (this.enableCompanyType == 'CompanyLogin') {
          const closeType =
            this.verifyMode === 'mobile'
              ? 'Step2-Verify your phone'
              : 'Step1-Verify your email address';
          this._companyManagementService.authentication_error(closeType,result.message);
        }else{
          if (this.authTypes == 'Onboard') {
            this._datalayer.errors_occured(result.message, this.data?.userType == '0' ? 'Admin' : 'Employee');
          }
        }
        this.markInvalidOtp();
        this.isVerifying = false;

      } else if (result && !result.success) {
        this.isVerifying = false;
      }
    } catch (err: any) {
      // authentication_error gtm
      const errMessage = err?.error?.message || err?.message;
      if (this.enableCompanyType == 'CompanyLogin') {
        const closeType =
            this.verifyMode === 'mobile'
              ? 'Step2-Verify your phone'
              : 'Step1-Verify your email address';
        this._companyManagementService.authentication_error(closeType,err.message);
        this._companyManagementService.view_error_message(errMessage,err.code)
      }else{
        if (this.authTypes == 'Onboard') {
          this._datalayer.errors_occured(err.message,this.data?.data?.userType == '0' ? 'Admin' : 'Employee');
        }
      }
      
      this.isVerifying = false;
      console.error(err);
      this.markInvalidOtp();
    }
  }

  ngOnDestroy(): void {
    if (this.timerInterval) clearInterval(this.timerInterval);
    this.destroy$.next();
    this.destroy$.complete();
  }

}
